import React from 'react';
import { Link } from 'react-router-dom';

const Habits = () => {
    return (
        <div className="page-container habits-page">
            <h1 className="page-title">Healthy Habits</h1>

            {/* Include the image */}
            <img
                src="/images/wf-habits2.jpg" // Path to image in public folder
                alt="Person practicing healthy habits"
                className="page-image"
            />

            <p className="page-intro">
                Welcome to the Healthy Habits section of Wholeness Forward. Building healthy habits is key to improving both physical and mental well-being, and it's essential for living a balanced and fulfilled life.
            </p>

            <p className="page-text">
                Healthy habits form the foundation of a healthy lifestyle. Whether it’s eating well, exercising, practicing mindfulness, or managing stress, creating and maintaining positive habits is a powerful way to take control of your health and well-being.
            
                It’s important to understand that habits are formed over time, and they require consistency and dedication. 
            </p>

            <p className="page-text">
                Additionally, while it’s essential to build positive habits, it's equally important to reduce or eliminate the bad habits that may be hindering your progress. Whether it's breaking free from unhealthy eating, overcoming procrastination, or managing stress more effectively, you have the power to make changes that align with your goals and values. Building positive habits and reducing negative ones is a transformative journey that can lead to lasting improvement in your overall well-being.
            </p>

            <hr className="page-divider" />

            <h2 className="section-title">Subtopics to Explore</h2>
            <li><Link to="/habits/basics" className="content-link">Habit Basics</Link></li>
            {/* <ul className="content-list">
                <li><Link to="/habits/buildinghabits" className="content-link">Building Healthy Habits</Link></li>
                <li><Link to="/habits/mentalhealth" className="content-link">Mental Health Habits</Link></li>
                <li><Link to="/habits/physicalhealth" className="content-link">Physical Health Habits</Link></li>
                <li><Link to="/habits/nutrition" className="content-link">Nutrition Habits</Link></li>
                <li><Link to="/habits/exercise" className="content-link">Exercise Routines</Link></li>
                <li><Link to="/habits/sleep" className="content-link">Sleep and Rest Habits</Link></li>
            </ul> */}

            <hr className="page-divider" />

            <h3 className="subheading">Community Habit Discussion</h3>
            <p className="page-text">
                Building healthy habits is easier when you have the support of others. Join our forum to share your progress, challenges, and tips for building lasting habits. Whether you're just starting or looking to improve your existing routines, connecting with like-minded individuals can motivate you to stay on track.
            </p>
            <a href="/forum/Habits" className="btn">Join the Habit Discussion</a>
        </div>
    );
};

export default Habits;
